import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import ComparisonTable from "./components/ComparisonTable";
import ContentSection from "./components/ContentSection";
import CtaSection from "./components/CtaSection";
import Footer from "./components/Footer";
import ArticleGrid from "./components/ArticleGrid";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ComparisonTable />
        <ContentSection />
        <ArticleGrid />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}